import { render, staticRenderFns } from "./QuotaCustomerMonthRatio.vue?vue&type=template&id=50f4a5ec&scoped=true&"
import script from "./QuotaCustomerMonthRatio.vue?vue&type=script&lang=js&"
export * from "./QuotaCustomerMonthRatio.vue?vue&type=script&lang=js&"
import style0 from "./QuotaCustomerMonthRatio.vue?vue&type=style&index=0&id=50f4a5ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4a5ec",
  null
  
)

export default component.exports